import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DatePicker.module.css';

/**
 * Styled DatePicker Component
 * Wraps react-datepicker with JACKOPOT theme styling
 */
const StyledDatePicker = ({ 
  selected, 
  onChange, 
  placeholder = 'Select date',
  minDate = null,
  maxDate = null,
  showTimeSelect = false,
  dateFormat = 'MM/dd/yyyy',
  ...props 
}) => {
  return (
    <div className={styles.datePickerWrapper}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        placeholderText={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        showTimeSelect={showTimeSelect}
        dateFormat={dateFormat}
        className={styles.datePickerInput}
        calendarClassName={styles.datePickerCalendar}
        wrapperClassName={styles.datePickerContainer}
        {...props}
      />
    </div>
  );
};

export default StyledDatePicker;
